import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=090e3106&scoped=true&"
import script from "./Welcome.vue?vue&type=script&lang=js&"
export * from "./Welcome.vue?vue&type=script&lang=js&"
import style0 from "./Welcome.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Welcome.vue?vue&type=style&index=1&id=090e3106&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090e3106",
  null
  
)

export default component.exports